import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mx-auto my-3" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "row mx-auto my-3" }
const _hoisted_5 = { class: "col-sm-12 col-md-6" }
const _hoisted_6 = { class: "col-sm-12 col-md-6" }
const _hoisted_7 = { class: "row mx-auto my-3" }
const _hoisted_8 = { class: "col-sm-12 col-md-6" }
const _hoisted_9 = { class: "col-sm-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alerts = _resolveComponent("alerts")!
  const _component_pending_visits = _resolveComponent("pending-visits")!
  const _component_financial_report = _resolveComponent("financial-report")!
  const _component_tab = _resolveComponent("tab")!
  const _component_scheduled_visits = _resolveComponent("scheduled-visits")!
  const _component_scheduled_training_sessions = _resolveComponent("scheduled-training-sessions")!
  const _component_completed_visits = _resolveComponent("completed-visits")!
  const _component_completed_training_sessions = _resolveComponent("completed-training-sessions")!
  const _component_canceled_visits = _resolveComponent("canceled-visits")!
  const _component_canceled_training_sessions = _resolveComponent("canceled-training-sessions")!
  const _component_tabs = _resolveComponent("tabs")!

  return (_openBlock(), _createBlock(_component_tabs, {
    options: { useUrlFragment: false },
    "nav-class": "nav nav-pills m-3",
    "nav-item-class": "nav-item col-md-4 col-sm-12 text-center",
    "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
    "nav-item-link-active-class": "active"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='far fa-clock text-primary'></i></h4>",
        name: "Pending"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          _createVNode(_component_alerts, { alerts: _ctx.alerts }, null, 8, ["alerts"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_pending_visits, {
                pending_visits: _ctx.pending_visits,
                pending_visits_total: _ctx.pending_visits_total,
                visit_loading: _ctx.pending_visits_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["pending_visits", "pending_visits_total", "visit_loading", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_financial_report, { financial_data: _ctx.financial_data }, null, 8, ["financial_data"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='far fa-calendar-alt text-primary'></i></h4>",
        name: "Scheduled"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          _createVNode(_component_alerts, { alerts: _ctx.alerts }, null, 8, ["alerts"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_scheduled_visits, {
                scheduled_visits: _ctx.scheduled_visits,
                scheduled_visits_total: _ctx.scheduled_visits_total,
                visit_loading: _ctx.scheduled_visits_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["scheduled_visits", "scheduled_visits_total", "visit_loading", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_financial_report, { financial_data: _ctx.financial_data }, null, 8, ["financial_data"]),
              _createVNode(_component_scheduled_training_sessions, {
                scheduled_training_sessions: _ctx.scheduled_training_sessions,
                scheduled_training_sessions_total: _ctx.scheduled_training_sessions_total,
                loading: _ctx.scheduled_training_sessions_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["scheduled_training_sessions", "scheduled_training_sessions_total", "loading", "onChangePage"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='fas fa-check text-primary'></i></h4>",
        name: "Completed"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          _createVNode(_component_alerts, { alerts: _ctx.alerts }, null, 8, ["alerts"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_completed_visits, {
                completed_visits: _ctx.completed_visits,
                completed_visits_total: _ctx.completed_visits_total,
                visit_loading: _ctx.completed_visits_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["completed_visits", "completed_visits_total", "visit_loading", "onChangePage"]),
              _createVNode(_component_completed_training_sessions, {
                completed_training_sessions: _ctx.completed_training_sessions,
                completed_training_sessions_total: _ctx.completed_training_sessions_total,
                loading: _ctx.completed_training_sessions_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["completed_training_sessions", "completed_training_sessions_total", "loading", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_financial_report, { financial_data: _ctx.financial_data }, null, 8, ["financial_data"]),
              _createVNode(_component_canceled_visits, {
                canceled_visits: _ctx.canceled_visits,
                visit_loading: _ctx.canceled_visits_loading
              }, null, 8, ["canceled_visits", "visit_loading"]),
              _createVNode(_component_canceled_training_sessions, {
                canceled_training_sessions: _ctx.canceled_training_sessions,
                canceled_training_sessions_total: _ctx.canceled_training_sessions_total,
                loading: _ctx.canceled_training_sessions_loading,
                onChangePage: _ctx.changePage
              }, null, 8, ["canceled_training_sessions", "canceled_training_sessions_total", "loading", "onChangePage"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}